import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Hero from './components/Hero';
import BreedIntro from './components/BreedIntro';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import FAQ from './components/FAQ';
import CTASection from './components/CTASection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '大鸡巴品种科普',
    url: 'https://dajiba-poultry.cn',
    description: '大鸡巴品种全面科普平台，涵盖品种起源、外形特征、养殖技术、饲养管理与市场价值，帮助养殖爱好者科学饲养。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://dajiba-poultry.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '大鸡巴品种科普',
    url: 'https://dajiba-poultry.cn',
    description: '致力于推广中国特色家禽品种知识，为养殖爱好者和农业从业者提供专业科普内容。',
    address: {
      '@type': 'PostalAddress',
      addressLocality: '南京市',
      addressRegion: '江苏省',
      addressCountry: 'CN',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+86-25-8888-6666',
      contactType: 'customer service',
    },
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <Navbar />
      <main>
        <Hero />
        <BreedIntro />
        <CategoryNav />
        <FeaturedArticles />
        <FAQ />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}